$(function () {
    $(".switch").on("click", function () {
        $(".bg-switch").toggleClass("featured");
        $(".switch p").toggleClass("white");
        $(".switch p").toggleClass("black");
        $(".lista-collabs-content .lista").toggleClass("featured");
    })
    
    $(".indice .indici a").on("click", function (evt) {
        $(".indice .indici a.attivo").removeClass("attivo");
        $(this).addClass("attivo");
    })
})